import React, { CSSProperties } from 'react';

type Props = {
  title: string;
  value: string | number;
  subtitle?: string;
  accent?: string;
  stagger?: 1 | 2 | 3 | 4 | 5 | 6;
  className?: string;
};

export function StatCard({ title, value, subtitle, accent, stagger, className = '' }: Props) {
  const staggerClass = stagger ? `odc-stagger-${stagger}` : '';
  const style = accent
    ? ({ ['--stat-color' as string]: accent } as CSSProperties)
    : undefined;

  return (
    <div className={`odc-stat-card ${staggerClass} ${className}`.trim()} style={style}>
      <p className="text-[10px] font-bold uppercase tracking-[0.15em]" style={{ color: 'var(--muted)' }}>
        {title}
      </p>
      <p className="odc-metric mt-1" style={{ color: accent || 'var(--text)' }}>
        {value}
      </p>
      {subtitle ? (
        <p className="mt-1 text-[11px]" style={{ color: 'var(--muted)' }}>
          {subtitle}
        </p>
      ) : null}
    </div>
  );
}
